import { createContext } from 'react';
import { Permission } from '../authorisation/permission';

export type UserDetails = {
  name: string;
  permissions: Array<Permission>;
};

export type UserContextValue = {
  getUser: () => UserDetails;
};

export const UserContext = createContext<UserContextValue>({
  getUser: () => {
    throw new Error('User context is not initialised yet');
  },
});
